import { isConsultantHeldRow, Team } from '@this+that/models';

import type { TeamHubCard } from '../hooks/useTeamHub';

export enum TEAM_BUCKET {
  YOUR_TEAMS = 'YOUR_TEAMS',
  CLIENT_IN_SETUP = 'CLIENT_IN_SETUP',
  CLIENT_DELIVERED = 'CLIENT_DELIVERED',
}

function toConsultantHeldRow(card: TeamHubCard): Team {
  return {
    name: card.name,
    userRole: card.myRole,
    consultingTeam: card.consultingTeam,
    trialHandedOffAt: card.trialHandedOffAt,
  };
}

function bucketFor(card: TeamHubCard): TEAM_BUCKET {
  if (!isConsultantHeldRow(toConsultantHeldRow(card))) {
    return TEAM_BUCKET.YOUR_TEAMS;
  }
  return card.trialHandedOffAt
    ? TEAM_BUCKET.CLIENT_DELIVERED
    : TEAM_BUCKET.CLIENT_IN_SETUP;
}

export function bucketTeamHubCards(
  cards: TeamHubCard[],
): Record<TEAM_BUCKET, TeamHubCard[]> {
  const buckets: Record<TEAM_BUCKET, TeamHubCard[]> = {
    [TEAM_BUCKET.YOUR_TEAMS]: [],
    [TEAM_BUCKET.CLIENT_IN_SETUP]: [],
    [TEAM_BUCKET.CLIENT_DELIVERED]: [],
  };

  cards.forEach((card) => {
    buckets[bucketFor(card)].push(card);
  });

  return buckets;
}
